var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ob1-price", class: _vm.complementaryClass },
    [
      _c("p", { staticClass: "visually-hidden" }, [
        _vm._v("\n        " + _vm._s(_vm.priceAccessibility) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "p",
        { attrs: { "aria-hidden": "true" } },
        [
          _vm.multiplePrice
            ? [
                _c("span", { staticClass: "small fw-bold" }, [
                  _vm._v("à partir de"),
                ]),
                _vm._v(" "),
                _c("br"),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isPriceInversionEnabled
            ? [
                _c(
                  "span",
                  {
                    class: _vm.customPrice
                      ? "ob1-price-amount-custom"
                      : "ob1-price-amount",
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("centsHandler")(
                          _vm._f("replacePointByComma")(
                            _vm.formattedMonthlyPrice
                          )
                        )
                      ) + " €"
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "ob1-price-by-month" }, [
                  _vm._v(_vm._s(" x " + _vm.monthlyDuration)),
                ]),
                _vm._v(" "),
                _vm.loanRateZeroLabel
                  ? [
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "ob1-price-amount-duration-custom text-dark fw-bold",
                        },
                        [_vm._v(_vm._s(_vm.loanRateZeroLabel))]
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "ob1-price-promo-duration d-inline fw-bold" },
                  [
                    _c("span", [
                      _vm._v(
                        "ou " +
                          _vm._s(
                            _vm._f("centsHandler")(
                              _vm._f("replacePointByComma")(
                                _vm.formattedTotalPriceWithPromo
                              )
                            )
                          ) +
                          " € "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.formattedTotalPriceWithoutPromo
                      ? _c("s", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm._f("centsHandler")(
                                  _vm._f("replacePointByComma")(
                                    _vm.formattedTotalPriceWithoutPromo
                                  )
                                )
                              ) +
                              " €\n                "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            : [
                _c("span", { staticClass: "ob1-price-amount" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("centsHandler")(
                        _vm._f("replacePointByComma")(
                          _vm.formattedTotalPriceWithPromo
                        )
                      )
                    ) + " €"
                  ),
                ]),
                _vm._v(" "),
                _vm.formattedTotalPriceWithoutPromo
                  ? _c("s", { staticClass: "ob1-price-without-promo-beside" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("centsHandler")(
                            _vm._f("replacePointByComma")(
                              _vm.formattedTotalPriceWithoutPromo
                            )
                          )
                        ) + " €\n            "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.paymentInfoLabel
                  ? _c("span", {
                      staticClass: "ob1-price-promo-duration fw-bold",
                      domProps: { innerHTML: _vm._s(_vm.paymentInfoLabel) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.loanRateZeroLabel
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ob1-price-amount-duration-custom text-dark fw-bold",
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.loanRateZeroLabel) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }